// extracted by mini-css-extract-plugin
export default {"container":"Qrscan_container__0sGzp","result":"Qrscan_result__MLwjJ"};